import { createTheme } from '@mui/material/styles'
import { colors, typography, zIndex } from './designTokens'

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		twoCol: true
		xxl: true
	}

	interface ZIndex {
		stickyHeader: number
	}
}

export const theme = createTheme({
	zIndex: {
		stickyHeader: zIndex.stickyHeader,
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			twoCol: 640, // Two-column card grid lower bound (Figma menu item grid spec)
			md: 721, // Figma desktop-small lower bound — 720px and below is mobile/tablet
			lg: 1025, // Figma desktop lower bound
			xl: 1280,
			xxl: 1440, // Figma wide-desktop frame — padding removed, content fills edge to edge
		},
	},
	typography: {
		fontFamily: typography.fontFamily,
	},
	palette: {
		primary: {
			main: colors.brand,
		},
		text: {
			primary: colors.textPrimary,
			secondary: colors.textSecondary,
			disabled: colors.textDisabled,
		},
		divider: colors.divider,
		error: {
			main: colors.error,
		},
		background: {
			paper: colors.surfaceWhite,
			default: colors.surfaceMuted,
		},
	},
})
